import { render } from "./SecurityReviewer.vue?vue&type=template&id=0a9b8691"
import script from "./SecurityReviewer.vue?vue&type=script&lang=js"
export * from "./SecurityReviewer.vue?vue&type=script&lang=js"

import "./SecurityReviewer.vue?vue&type=style&index=0&id=0a9b8691&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__